import Phaser from 'phaser';
import Intro from './intro';
import { language } from './language';
import { CST } from '../CST';

var clickSound;
export default class SelectTime extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.TIME);
	}
	preload() {
		this.load.image('bg-time', ' assets/english/time-screen.png');
		this.load.image('5min', 'assets/english/5min.png');
		this.load.image('10min', 'assets/english/10min.png');
		this.load.image('15min', 'assets/english/15min.png');
		this.load.image('30min', 'assets/english/30min.png');
		this.load.image('45min', 'assets/english/45min.png');
		this.load.image('60min', 'assets/english/60min.png');
		this.load.image('back_btn', 'assets/english/go-backwards.png');
	}

	create(data) {
		clickSound = this.sound.add('clickSound');
		this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'bg-time' + language);

		const fiveMin = this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2 - 25, '5min' + language)
			.setScale(1)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				clickSound.play();
				this.scene.stop();
				this.scene.start(CST.SCENES.INTRO, { data: 300 });
			});

		const tenMin = this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2 + 85, '10min' + language)
			.setScale(1)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				clickSound.play();
				this.scene.stop();
				this.scene.start(CST.SCENES.BOARD, { data: 600 });
			});

		// const fifteenMin = this.add
		//   .image(
		//     this.cameras.main.width / 2 - 150,
		//     this.cameras.main.height / 2 - 40,
		//     "15min" + language
		//   )
		//   .setScale(1)
		//   .setInteractive({ useHandCursor: true });
		// fifteenMin.on("pointerdown", () => {
		//   clickSound.play();
		//   this.scene.stop();
		//   // this.scene.start(CST.SCENES.BOARD, { data: 360 });
		//   this.scene.start(CST.SCENES.INTRO, { data: 900 });
		// });

		// const thirty = this.add
		//   .image(
		//     this.cameras.main.width / 2 + 150,
		//     this.cameras.main.height / 2 - 40,
		//     "30min" + language
		//   )
		//   .setScale(1)
		//   .setInteractive({ useHandCursor: true });
		// thirty.on("pointerdown", () => {
		//   clickSound.play();
		//   this.scene.stop();
		//   this.scene.start(CST.SCENES.INTRO, { data: 1800 });
		// });

		// const fortyfiveMin = this.add
		//   .image(
		//     this.cameras.main.width / 2 - 150,
		//     this.cameras.main.height / 2 + 100,
		//     "45min" + language
		//   )
		//   .setScale(1)
		//   .setInteractive({ useHandCursor: true });
		// fortyfiveMin.on("pointerdown", () => {
		//   clickSound.play();
		//   this.scene.stop();
		//   this.scene.start(CST.SCENES.INTRO, { data: 2700 });
		// });

		// const sixty = this.add
		//   .image(
		//     this.cameras.main.width / 2 + 150,
		//     this.cameras.main.height / 2 + 100,
		//     "60min" + language
		//   )
		//   .setScale(1)
		//   .setInteractive({ useHandCursor: true })
		// sixty.on("pointerdown", () => {
		//   clickSound.play();
		//   this.scene.stop();
		//   this.scene.start(CST.SCENES.INTRO, { data: 3600 });
		// });

		this.back = this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2 + 185, 'back_btn')
			.setScale(1.2)
			.setInteractive({
				useHandCursor: true,
			})
			.on('pointerdown', () => {
				clickSound.play();
				this.scene.start(CST.SCENES.MENU);
			});

		this.events.on('start', () => {
			if (data.scene === CST.SCENES.INTRO) {
				this.scene.remove(CST.SCENES.INTRO);
				this.scene.add(CST.SCENES.INTRO, Intro, false);
			}
		});

		if (/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
			this.back.x = this.cameras.main.width / 2 - 665;
			this.back.y = this.cameras.main.height / 2 - 400;
		}
	}
}
